import React from 'react';
import { Spinner } from 'react-bootstrap';

const spinnerBorder = {
  width: '5rem',
  height: '5rem',
}

class Content extends React.Component {
  render() {
    if (this.props.loading) {
      return (
        <div className={`position-relative text-center mb-4 w-100 ${this.props.className || ''}`}>
          <Spinner
              animation="border"
              style={spinnerBorder}
              size="lg"
            />
        </div>
      );
    }

    return this.props.children;
  }
}

export default Content;
